import { submitRequestWithPromise } from './BaseServiceTs';
import {environment} from './environment';
import {GET} from './RequestMethods';


export const fetchCountries = () => {
    return submitRequestWithPromise(GET, environment.apiEndPoint, 'lists/countries', {});
};

export const fetchAddresses = () => {
    return submitRequestWithPromise(GET, environment.apiEndPoint, 'users/check/address', {});
};


